import axios, {AxiosInstance, AxiosResponse} from 'axios';
import {toast} from "react-toastify";
import {Response} from "../entities/Response";

const hostname = window.location.hostname;
let baseURL: string;
if (hostname.includes('localhost') || hostname.includes('test')) {
    // 测试环境
    baseURL = 'https://test.nginx.haiskynology.com';
} else if (hostname.includes('staging')) {
    // 预发布环境
    baseURL = 'https://staging.nginx.haiskynology.com';
} else {
    // 生产环境
    baseURL = 'https://nginx.haiskynology.com';
}

export function createApiClient({ timeoutInMills = 3000 } = {}): AxiosInstance {
    const apiClient: AxiosInstance = axios.create({
        baseURL: baseURL,
        timeout: timeoutInMills, // 设置超时时间
    });
    // 请求拦截器：统一处理 Cookie 和添加其他请求头（如 token）
    apiClient.interceptors.request.use(
        (value) => {
            // const accessToken = LoginUtils.getAccessToken();
            // if (accessToken && accessToken.length > 0) {
            //     value.headers['Authorization'] = `Bearer ${accessToken}`;
            // }
            return value;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 响应拦截器：统一处理响应数据
    apiClient.interceptors.response.use(
        async (response: AxiosResponse) => {
            // 这里统一处理响应数据，解析 data、code 和 message
            const { code, message } = response.data;
            // show toast error
            if (code === 401 || code === 401005) {
                // LoginUtils.logout();
                // const accessToken = LoginUtils.getAccessToken();
                // if (accessToken && accessToken.length > 0) {
                //     toast.error(responseMessage);
                // }
            } else if (code === 401004) {
                // try {
                //     // 尝试刷新 accessToken
                //     const loginToken = await UserService.refreshAccessToken();
                //     if (loginToken){
                //         return apiClient.request(response.config as AxiosRequestConfig);
                //     }
                // } catch (refreshError) {
                //     // 如果刷新失败，跳转到登录页面
                //     LoginUtils.logout();
                // }
            } else if (code !== 200) {
                console.error(`request failed, url ${response.config.url} request ${response.config.data} message ${message}`);
                toast.error(message, { autoClose: 5000 });
            } else {
                if (message) {
                    toast.info(message);
                }
            }
            const customResponse = new Response();
            if (response.data) {
                Object.assign(customResponse, response.data);
            }
            response.data = customResponse;
            return response.data;
        },
        (error) => {
            // 错误处理
            if (error.response) {
                // 后端返回的错误
                toast.error(error.response.data.message || '服务器错误');
                return Promise.reject(new Error(error.response.data.message || '服务器错误'));
            } else if (error.request) {
                toast.error('请求没有响应');
                return Promise.reject(new Error('请求没有响应'));
            } else {
                // 请求设置错误
                toast.error(error.message || '未知错误');
                return Promise.reject(new Error(error.message || '未知错误'));
            }
        }
    );
    return apiClient;
}

const apiClient = createApiClient();
export default apiClient;